import { ModulesConfigMap, ModulesMap } from '../data/modulesMaps'
// import { STORE_MAP } from '@/config/cache/cache-engine'

export default {
	getLogisticRoutesGeoZones: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.LOGISTIC_ROUTES_GEO_ZONES].GET_LOGISTIC_ROUTES_GEO_ZONES,
	},
	getLogisticRoutesGeoZonePreview: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.LOGISTIC_ROUTES_GEO_ZONES].GET_LOGISTIC_ROUTES_GEO_ZONE_PREVIEW,
	},
	getLogisticRoutesGeoZonePopup: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.LOGISTIC_ROUTES_GEO_ZONES].GET_LOGISTIC_ROUTES_GEO_ZONE_POPUP,
	},
	getLogisticRoutesGeoZone: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.LOGISTIC_ROUTES_GEO_ZONES].GET_LOGISTIC_ROUTES_GEO_ZONE,
	},
	createLogisticRoutesGeoZone: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.LOGISTIC_ROUTES_GEO_ZONES].CREATE_LOGISTIC_ROUTES_GEO_ZONE,
	},
	putLogisticRoutesGeoZone: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.LOGISTIC_ROUTES_GEO_ZONES].PUT_LOGISTIC_ROUTES_GEO_ZONE,
	},
	patchLogisticRoutesGeoZone: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.LOGISTIC_ROUTES_GEO_ZONES].PATCH_LOGISTIC_ROUTES_GEO_ZONE,
	},
	deleteLogisticRoutesGeoZone: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.LOGISTIC_ROUTES_GEO_ZONES].DELETE_LOGISTIC_ROUTES_GEO_ZONE,
	},
}
